import React, {Component} from 'react';
import { connect } from "react-redux";
import Footer from "../Main/Footer"
import Loading from "../../Components/loading/loading"
import {config} from "../../Reducers/auth/actions"
class Account extends Component {
  componentWillMount() {
    this.props.config();
  }
  render() {
    return (
      <div className="sneat-auth-wrapper">
        <div className="sneat-auth-inner">
          <div className="sneat-auth-card">
            <div className="sneat-auth-header">
              <div className="sneat-auth-logo">
                <img src="/brand/logo.png" alt='Logo recraplan' className="sneat-logo"/>
              </div>
              <h1 className="sneat-auth-title">Welcome to RecraPlan</h1>
              <p className="sneat-auth-subtitle">Manage your recreation business with ease</p>
            </div>
            
            <div className="sneat-auth-content">
              <Loading/>
              {this.props.children}
            </div>
          </div>
          
          <div className="sneat-auth-footer">
            <Footer className="main-footer"/>
          </div>
        </div>
      </div>
    );
  }
};

function mapStateToProps(state) {
  return { config: state.auth.config };
}

export default connect(
  mapStateToProps,
  { config }
)(Account);
